import axios from 'axios'

class ConnectDeviceService {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  connectDevice() {
    return axios.get(`${this.baseUrl}healthdashboard/provision_user/`)
  }

  getBiometricData() {
    return axios.get(`${this.baseUrl}healthdashboard/get_vitals_data/`)
  }

  getValidicWearableData(userId, deviceType) {
    return axios.get(
      `${this.baseUrl}wearables/vitals/?validic_uid=${userId}&device_type=${deviceType}`
    )
  }

  getValidicUserMarketplaceDevices() {
    return axios.get(`${this.baseUrl}healthdashboard/add_device_validic/`)
  }

  getVitals(uid, deviceType) {
    return axios.get(
      `${this.baseUrl}wearables/vitals/?validic_uid=${uid}&device_type=${deviceType}`
    )
  }

  getVitalSettings(userId) {
    return axios.get(`${this.baseUrl}users/vitals_status/${userId}`)
  }

  updateVitalSettings(userId, vitalsStatus) {
    return axios.post(`${this.baseUrl}users/update_vitals_status/`, {
      user_id: userId,
      vitals_status: vitalsStatus,
    })
  }

  connectWithDevice(validicUID, deviceType) {
    return axios.post(`${this.baseUrl}wearables/connect/`, {
      validic_uid: validicUID,
      device_type: deviceType,
    })
  }

  disconnectWithDevice = async (validicUID, deviceType) => {
    return axios.post('/wearables/disconnect/', {
      validic_uid: validicUID,
      device_type: deviceType,
    })
  }
}

export const connectDeviceService = new ConnectDeviceService()
